export default __webpack_public_path__ + "static/media/banner.aea1ef62.png";